import * as React from "react";
const GreenTickMarkSvg = (props) => (
  <svg
    width={62}
    height={59}
    viewBox="0 0 62 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={62} height={58.268} rx={29.134} fill="#E6F6F4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m42.874 16.686-17.906 17.28-4.75-5.076c-.876-.826-2.251-.875-3.252-.175-.975.725-1.25 2-.65 3.026l5.627 9.152c.55.85 1.5 1.375 2.575 1.375a3.06 3.06 0 0 0 2.551-1.375c.9-1.175 18.08-21.656 18.08-21.656 2.25-2.3-.475-4.326-2.276-2.576z"
      fill="#12B76A"
    />
  </svg>
);
export default GreenTickMarkSvg;
